import React from "react";
import { HiOutlineExclamationCircle } from "react-icons/hi";

/**
 * Visual style config per lifecycle card type.
 * Extend here when upsell / expansion cards are added.
 */
const CARD_STYLES = {
  communicated_churn: {
    icon: HiOutlineExclamationCircle,
    iconClass: "text-amber-500",
    badgeClass: "bg-amber-50 border-amber-200",
    labelClass: "text-amber-700",
    valueClass: "text-amber-900",
    subtitleClass: "text-amber-600",
  },
};

const DEFAULT_STYLE = {
  icon: HiOutlineExclamationCircle,
  iconClass: "text-gray-400",
  badgeClass: "bg-gray-50 border-gray-200",
  labelClass: "text-gray-600",
  valueClass: "text-gray-900",
  subtitleClass: "text-gray-500",
};

/**
 * LifecycleCard — renders a single account lifecycle state (e.g. communicated churn).
 *
 * Props:
 *   card: { type, label, value, subtitle }
 */
export const LifecycleCard = ({ card }) => {
  const style = CARD_STYLES[card.type] || DEFAULT_STYLE;
  const Icon = style.icon;

  return (
    <div
      className={`flex items-start gap-3 rounded-lg border p-4 ${style.badgeClass}`}
    >
      <Icon className={`mt-0.5 size-5 shrink-0 ${style.iconClass}`} />
      <div className="min-w-0 flex-1">
        <p
          className={`text-xs font-medium uppercase tracking-wide ${style.labelClass}`}
        >
          {card.label}
        </p>
        <p className={`mt-0.5 text-sm font-semibold ${style.valueClass}`}>
          {card.value}
        </p>
        {card.subtitle && (
          <p className={`mt-0.5 text-xs ${style.subtitleClass}`}>
            Expected {card.subtitle}
          </p>
        )}
      </div>
    </div>
  );
};
